// extracted by mini-css-extract-plugin
module.exports = {"textCell":"idt-textinputcontrolwindow_textcell__1_kqy","textPreview":"idt-textinputcontrolwindow_textpreview__1e0yz"};